document.addEventListener('DOMContentLoaded', () => {
  const cards = document.querySelectorAll('[data-modal-target]');
  const closeTriggers = document.querySelectorAll('[data-modal-close]');
  let activeModal = null;

  function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;
    
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
    activeModal = modal;
  }

  function closeModal() {
    if (!activeModal) return;
    
    activeModal.classList.remove('is-open');
    activeModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    activeModal = null;
  }

  cards.forEach(card => {
    card.addEventListener('click', () => {
      const targetId = card.getAttribute('data-modal-target');
      openModal(targetId);
    });
  });

  closeTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      closeModal();
    });
  });

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && activeModal) {
      closeModal();
    }
  });
});
